import React from 'react';
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';
import '../../css/shared/RespModal.css';
function RespModal(props) {
  return (
    <div>
    <Modal open={props.hasOpen} closeOnOverlayClick={false} closeIcon=' ' center>
      <div id="respmodeldiv" {...props}>
        {props.children}
      </div>
    </Modal>
    </div>
  );
}
export default RespModal;